import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, OnDestroy, Injector, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { AppComponent } from './app.component';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';
import { ApplicationContextService, AuthenService, ComCtxConstants, CommonService, ComponentContextService, CoreConfigService, CrudFormData, Filter, Operator, PopupSize, StorageUpdatedService, UserService } from 'tnx-shared';
import { MenuItem } from 'tn-custom-primeng/api';
import { AppUserService } from './reset-password/services/app-user.service';
import { KhoaLichService } from 'projects/frontend-service/src/lib/services/khoa-lich.service';

@Component({
    selector: 'app-anonymous-topbar',
    templateUrl: './app-anonymous.topbar.component.html',
    // providers: [ComponentContextService],
    styleUrls: ['./app-anonymous.topbar.component.scss']
})
export class AppAnonymousTopBarComponent implements OnInit {

    isShow: boolean;
    defaultAvatar = environment.appMetadata.main.defaultMaleAvatar;
    readonly CURRENT_USER_KEY = 'current_user_info';
    readonly USER_KEY = 'user_info';
    @ViewChild('dropdown') dropItem: ElementRef;
    items: MenuItem[];
    changed = false;

    loggedMenu = [];

    showDetailForm = false;
    popupSizeXacNhan: PopupSize = new PopupSize({
        width: 500,
        height: 300,
        maximize: false
    });
    xacNhanFormHeader = 'Xác nhận thông tin';
    confirm = false;
    menuLogOut: MenuItem[];
    firstTime = true;

    showResetPasswordForm = false;
    formModelReset: CrudFormData = new CrudFormData();
    formModelLockLich: CrudFormData = new CrudFormData();

    showLockLichForm = false;
    khoaLichItem: any;

    constructor(
        public app: AppComponent,
        private _oauthService: OAuthService,
        public _injector: Injector,
        private _coreConfigService: CoreConfigService,
        public _router: Router,
        public _commonService: CommonService,
        public _componentContextService: ComponentContextService,
        private _activatedRoute: ActivatedRoute,
        private _appUserService: AppUserService,
        private _authenService: AuthenService,
        private _khoaLichService: KhoaLichService
    ) {
        this.isShow = false;


        this._activatedRoute.queryParams.subscribe(rs => {
            if (rs['code']) {
                this._oauthService.loadDiscoveryDocumentAndTryLogin().then(rs => {
                    console.log('test', rs);
                    if (!this._oauthService.hasValidAccessToken()) {
                        this._oauthService.initLoginFlow();
                    } else {
                        const user = this._oauthService.getIdentityClaims();

                        if (user && (user['issuperuser'].toLowerCase() == 'true' || user['isadmin'].toLowerCase() == 'true')) {
                            localStorage.removeItem('user_info');
                            localStorage.removeItem('item_detail');
                            this._authenService.logout();
                            return;
                        }
                    }
                });
            }
        });
        // const user = localStorage.getItem(this.USER_KEY);
        // if (!user || user == 'null') {
        //     const userInfo = this._oauthService.getIdentityClaims();
        //     localStorage.setItem(this.USER_KEY, JSON.stringify(userInfo));
        // }
    }

    ngOnInit() {
        // this.completeAuthentication();
        this.initLoggedMenu();
        this.getMenuBar();
        this.checkKhoaLich();

        this.menuLogOut = [
            {
                label: 'Thay đổi mật khẩu',
                command: () => {
                    this.onShowChangePasswordForm();
                },
            },
            {
                label: 'Đăng xuất',
                icon: 'fas fa-fw fa-sign-out-alt',
                command: () => this.onTopbarLogout()
            }
        ];
        this._componentContextService.subscribe('COMPLETE_AUTHEN', data => {
            this.initLoggedMenu();
            this.getMenuBar();
            this.checkKhoaLich();
        });
    }

    onShowChangePasswordForm() {
        // Get thong tin user
        const userInfo = localStorage.getItem(this.USER_KEY);
        if (userInfo) {
            const user = JSON.parse(userInfo);
            if (user.sub) {
                this._appUserService.getDetail(user.sub).then(response => {
                    this.formModelReset.data = response.data;
                    this.formModelReset.data.passwordHash = '';
                    this.showResetPasswordForm = true;
                })
            }
        }
    }

    async checkKhoaLich() {
        // Get thong tin user
        const userInfo = localStorage.getItem(this.USER_KEY);

        if (!userInfo || !this._oauthService.hasValidAccessToken()) {
            return;
        }
        const filters = [
            this.newFilter('trangThai', Operator.equal, 1),
        ];
        const response = await this._khoaLichService.getDetailByFilter(filters);
        if (response.data) {
            if (new Date(response.data.tuNgay) <= new Date() && response.data.idSites.split(',').length == 7) {
                if (window.location.href.includes('dang-ky-kham'))
                    window.location.href = '/';
                else {
                    this.showLockLichForm = true;
                    this.khoaLichItem = response.data;
                }
            }
        }
    }

    newFilter(field: string, operator: Operator, value: any) {
        return new Filter({
            field, operator,
            value: JSON.stringify(value)
        });
    }

    handleResetPassword() {
        this.showResetPasswordForm = false;
    }

    handleCancelResetPasswordForm() {
        this.showResetPasswordForm = false;
    }

    initLoggedMenu() {
        const userInfo = localStorage.getItem(this.USER_KEY);

        if (userInfo && userInfo != 'null') {
            const user = JSON.parse(userInfo);
            return user.fullname;
        }
    }

    thongTinTaiKhoan() {
        const toChucDomain = (<any>environment.clientDomain).toChucDomain;
        window.location.href = `${toChucDomain}/tochuc-thongtintaikhoan`;
    }

    quanTriDoanhNghiep() {
        const toChucDomain = (<any>environment.clientDomain).toChucDomain;
        window.location.href = `${toChucDomain}/tochuc-thongtintaikhoan`;
    }

    login() {
        // lưu current vào localstorage
        this._oauthService.loadDiscoveryDocument().then(rs => {
            this._oauthService.initLoginFlow();
        });
    }

    onTopbarLogout() {
        // this._oauthService.logOut();
        localStorage.removeItem('user_info');
        localStorage.removeItem('item_detail');
        this._authenService.logout();
        // this._router.navigateByUrl('');
    }

    completeAuthentication() {
        const user = this._oauthService.getIdentityClaims();
        localStorage.setItem(this.USER_KEY, JSON.stringify(user));
        this.initLoggedMenu();
        this.getMenuBar();
    }

    getMenuBar() {
        const user = localStorage.getItem(this.USER_KEY);

        if (!user || user == 'null')
            return false;
        const userInfo = JSON.parse(user);
        this.items = [
            {
                label: 'ĐĂNG KÝ LỊCH HẸN',
                routerLink: '/sktqdn/authen/dang-ky-kham',
                visible: userInfo.source == '3' ? true : false
            },
            {
                label: 'TÌNH TRẠNG ĐĂNG KÝ KHÁM',
                routerLink: '/sktqdn/authen/tra-cuu',
                visible: userInfo.source == '2' ? true : false
            },
            {
                label: 'TÌNH TRẠNG KHÁM',
                routerLink: '/sktqdn/authen/tinh-trang-kham',
                visible: userInfo.source == '2' ? true : false
            },
            {
                label: 'KẾT QUẢ KHÁM',
                routerLink: '/sktqdn/authen/ket-qua-kham',
                visible: userInfo.source == '2' ? true : false
            },
            {
                label: 'CÂU HỎI THƯỜNG GẶP',
                routerLink: '/sktqdn/faq',
                visible: userInfo.source == '3' ? true : false
            }
        ];

    }

    isAuthenticated(): boolean {
        return this._oauthService.hasValidAccessToken();
    }

    showDialog() {
        // if (this.confirm) {
        //     return;
        // }
        this.showDetailForm = true;
    }
    handleCancel(evt) {
        this.showDetailForm = false;

    }
}
